
export const rfc3339 = (x, millis = false, local = false) => {
  const p2 = n => n<10 ? '0'+n : n;
  const p3 = n => n<10 ? '00'+n : n<100 ? '0'+n : n;
  const d = new Date(x);

  let s = local ?
    d.getFullYear()+'-'
      + p2(d.getMonth()+1)+'-'
      + p2(d.getDate())+' '
      + p2(d.getHours())+':'
      + p2(d.getMinutes())+':'
      + p2(d.getSeconds())
    : d.getUTCFullYear()+'-'
      + p2(d.getUTCMonth()+1)+'-'
      + p2(d.getUTCDate())+' '
      + p2(d.getUTCHours())+':'
      + p2(d.getUTCMinutes())+':'
      + p2(d.getUTCSeconds());

  if (millis) s += '.' + p3(d.getMilliseconds());
  if (!local) s += 'Z';
  return s;
}


export const fmtOffset = (ms) => {
  return '+' + (ms / 1000).toFixed(1);
}

export const shortID = x => x.slice(-8);
